import React from "react";
import styled from "styled-components";
import feature1 from "../assets/feature1.png";
import feature2 from "../assets/feature2.png";
import feature3 from "../assets/feature3.png";
import feature4 from "../assets/feature4.png";
import { Link } from "react-router-dom";

const Features = () => {
  return (
    <FeatureMain>
      <h2>Explore our amazing features</h2>
      <FeatureContainer>
        <FeatureCard>
          <img src={feature1} alt="" />
          <h3>
            User <br /> friendly UI
          </h3>
          <Link to="#">See details</Link>
        </FeatureCard>
        <FeatureCard>
          <img src={feature2} alt="" />
          <h3>
            Multiple Document <br /> Design Selection
          </h3>
          <Link to="#">See details</Link>
        </FeatureCard>
        <FeatureCard>
          <img src={feature3} alt="" />
          <h3>
            Payment <br /> Reminder
          </h3>
          <Link to="#">See details</Link>
        </FeatureCard>
        <FeatureCard>
          <img src={feature4} alt="" />
          <h3>
            24/7 <br /> Suppourt
          </h3>
          <Link to="#">See details</Link>
        </FeatureCard>
        <FeatureCard>
          <img src={feature1} alt="" />
          <h3>
            User <br /> friendly UI
          </h3>
          <Link to="#">See details</Link>
        </FeatureCard>
        <FeatureCard>
          <img src={feature2} alt="" />
          <h3>
            Multiple Document <br /> Design Selection
          </h3>
          <Link to="#">See details</Link>
        </FeatureCard>
        <FeatureCard>
          <img src={feature3} alt="" />
          <h3>
            Payment <br /> Reminder
          </h3>
          <Link to="#">See details</Link>
        </FeatureCard>
        <FeatureCard>
          <img src={feature4} alt="" />
          <h3>
            24/7 <br /> Suppourt
          </h3>
          <Link to="#">See details</Link>
        </FeatureCard>
      </FeatureContainer>
    </FeatureMain>
  );
};

export default Features;

const FeatureMain = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 4rem calc((100vw - 1000px) / 2);

  h2 {
    font-size: 40px;
    font-weight: 600;
    color: #20204f;
    line-height: 65px;
    margin-top: 15px;
    margin-bottom: 25px;
  }
  @media only screen and (max-width: 991px) {
    padding: 2rem calc((100vw - 1000px) / 2);
    h2 {
      font-size: 30px;
      font-weight: 600;
      text-align: center;
      line-height: 40px;
    }
  }
`;

const FeatureContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 1.5rem;

  @media only screen and (max-width: 991px) {
    grid-template-columns: 1fr;
  }
`;

const FeatureCard = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  background-color: #fff;
  border: 1px solid #c5c5c5;
  border-radius: 7px;
  width: 240px;
  height: 220px;
  padding-left: 25px;
  cursor: pointer;

  img {
    display: flex;
    align-items: flex-start;
    justify-content: center;
    width: 60px;
    height: 60px;
    margin-bottom: 15px;
  }
  h3 {
    font-size: 20px;
    font-weight: 600;
    color: #20204f;
    margin-top: 2px;
  }
  a {
    text-decoration: none;
    color: #c0bfbf;
    margin-top: 17px;
    font-weight: 500;
  }
  &:hover {
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.2);
    transform: scale(1.05);
    transition: all 0.5s ease-out;
  }
`;
